import React, { useState } from "react";
import { ReactComponent as PenNPaper } from "../../assets/analyse/PenNPaper.svg";
import { ReactComponent as Cherry } from "../../assets/analyse/Cherry.svg";
import { ReactComponent as Circle } from "../../assets/analyse/Circle.svg";
import { ReactComponent as Spark } from "../../assets/analyse/Spark.svg";
import { ReactComponent as Truck } from "../../assets/analyse/Truck.svg";
import { ReactComponent as Box } from "../../assets/analyse/Box.svg";
import "react-widgets/styles.css";
import AnalysisStep from "./AnalysisStep";
import "react-toastify/dist/ReactToastify.css";
import LineColumns from "./LineColumns";
import ModificationLine from "./ModificationLine";
import ReduceLineColumns from "./ReduceLineColumns";

const ReduceAnalysisLine = ({
  item,
  changable,
  quantity,
  quantityUnit,
  // impact,
  impact_factors,
  checked,
  // icon,
  ingredient_id,
  // width,
  totalScore,
  columns,
  step,
  line_index,
  flow_id,
  color,
  conversion_factor,
  is_reduce,
  impactt,
}) => {
  const [modifying, setModifying] = useState("");
  // var widthvalue = width - 29.5;
  // width -= 30;
  return (
    <>
      {/* {modifying ? (<ModificationLine icon={icon} item={item} data={changable} modifying={modifying} setModifying={setModifying} width={width}/>) : null} */}
      {/* {modifying ? (
        <ModificationLine
          // icon={icon}
          item={item}
          data={step > 2 ? changable : changable[flow_id]}
          flow_id={flow_id}
          modifying={modifying}
          setModifying={setModifying}
          width={width}
          step={step}
          line_index={line_index}
          imapct_factors={impact_factors}
          quantity={quantity}
          quantityUnit={quantityUnit}
          columns={columns}
        />
      ) : null} */}

      {/* <p onClick={() => {
        if (is_reduce) {
          console.log("tot", totalScore)
        }
        
      }}>LINE_RIGHT</p> */}

      <div
        className={`h-[40px] w-max flex justify-start ${is_reduce ? "" : "ml-[30px] "} ${
          modifying != 0 ? "bg-white border-gray-500 border-[1px] rounded" : color ? (color === "green" ? "bg-green-500/25" : "bg-yellow-400/25") : "bg-[#F8FAFB] border-[#F3F5F7] border-[0.1px]"
        } ${color ? (color === "green" ? "hover:bg-green-300/25" : "hover:bg-yellow-300/25") : "hover:bg-white border-[#F3F5F7] border-[0.1px]"}   items-center`}
      >
        <ReduceLineColumns
          checked={checked}
          columns={columns}
          // impact={impact}
          impact_factors={impact_factors}
          quantity={quantity}
          quantityUnit={quantityUnit}
          totalScore={totalScore}
          step={step}
          line_index={line_index}
          flow_id={flow_id}
          conversion_factor={conversion_factor}
          is_reduce={true}
          ingredient_id={ingredient_id}
          impactt={impactt}
        />
      </div>
    </>
  );
};

export default ReduceAnalysisLine;
